import { Modal } from '@sketch/components'
import { breakpoint } from '@sketch/global-styles'
import styled, { css } from 'styled-components'
import { ProjectsPickerWrapper } from '../../../projects/modals/ProjectPickerContent/ProjectPickerContent.styles'
import { LeftContent } from '@sketch/components/src/Modal/ModalFooter'
import { FootnoteText } from './MoveStorageItemModal.styles'

/** Maximum height of the modal as a percentage of viewport height */
export const MODAL_MAX_HEIGHT_VH = 80

export const ModalStyled = styled(Modal)`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 532px;
  height: auto;
  max-height: ${MODAL_MAX_HEIGHT_VH}vh;

  ${ProjectsPickerWrapper} {
    padding: 12px 8px;
  }
`

export const ResizableContentWrapper = styled.div<{ $minHeight?: number }>`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: ${({ $minHeight }) => ($minHeight ? `${$minHeight}px` : '360px')};
  position: relative;
`

export const ResizeHandle = styled.div`
  display: none;

  ${breakpoint('sm')`
    display: block;
    position: absolute;
    bottom: 0;
    right: 0;
    width: 16px;
    height: 16px;
    max-height: 16px;
    cursor: row-resize;
    overflow: hidden;
    resize: vertical;
    /* Safari needs a border to show the resize handle */
    border: 1px solid rgba(0, 0, 0, 0.01);
  `}
`

export const Footer = styled(Modal.Footer)<{ dimmed?: boolean }>`
  ${LeftContent} {
    display: inline-flex;
    margin-right: 16px;
    min-width: 0;
    max-width: 100%;
    overflow: hidden;

    ${breakpoint('sm')`
      flex: 1 1 auto;
    `}
  }

  ${LeftContent} ${FootnoteText} {
    min-width: 0;
  }

  & > div:last-child {
    width: 100%;

    ${breakpoint('sm')`
      width: auto;
      flex: 0 0 auto;
    `}
  }

  & > * {
    ${({ dimmed }) =>
      dimmed &&
      css`
        opacity: 0.3;
        pointer-events: none;
      `}
  }
`
